export default "<span class=\"status-badge {{tagStyle}}\" [attr.title]=\"tooltip? tooltip : null\">{{labelName}}</span>\n";